exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.submenuItem-title[data-v-34194c8e] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 50px;\n  line-height: 20px;\n  overflow: hidden;\n  white-space: break-spaces;\n  text-overflow: ellipsis;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34194c8e","scoped":true,"hasInlineConfig":false}!./~/postcss-loader/lib?sourceMap!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=1!./app/components/SideBar/Main.vue
// module id = 598
// module chunks = 40